// this model response is mapped based on the HANSEN8 > Notifications setup
// this includes the notification type and notification method and it's provider
// notification method can have multiple provider
define(function(require) {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
    return IpsModelCollection.extend({
      urlRoot: '/delegate/civics-api/api/resources/simplifiednotificationtypes',
      getNotificationMethodByType: function(notificationType, notificationMethod){
        let retValue = [];
        let notificationTypeObj = this.toJSON();
        _.each(notificationTypeObj, (type)=>{
          if(type.code == notificationType){
            _.each(type.notificationMethod, (method)=>{
              let isRequirePhoneNumber = true;
              _.each(method.provider, function (prov) {
                // when we have provider that is not SMS, we are not requiring phone number on this method
                if (prov.providerType != "SMS")
                  isRequirePhoneNumber = false;
              });

              // display for notification method is mapped on localization
              // if localization is not found, display the description instead
              let translationText = 'CIVICS.ACCOUNT.NOTIFICATION_METHODS.' + method.code.toUpperCase();
              let displayText = i18n.t(translationText);
                // i18n.t return the string we passed when translation is not found
                // so we are comparing it to the display text. If it is equal, set the description as displayText
                if(displayText == translationText){
                  displayText = method.description;
                } 
                
                let newRow = {
                  code: method.code,
                  description: method.description,
                  displayText: displayText,
                  isRequirePhoneNumber: isRequirePhoneNumber
                }
                // filter the notification method using the parameter notification method, break the loop after we push the result.
                if(!notificationMethod || (notificationMethod && notificationMethod == method.code)){
                  retValue.push(newRow);
                  if(notificationMethod)
                    return false;
                }
            });
          }
        });

        return retValue;
      }
    });
  });
  